import { useState } from 'react';
import { CategorySelector } from './CategorySelector';
import { allCategories } from '../data/categories';
import { FilterActionButton } from './FilterActionButton';

interface CategoriesFilterProps {
  onClose: () => void;
  selectedCategories?: string[];
  onCategoriesChange?: (categories: string[]) => void;
}

export function CategoriesFilter({
  onClose,
  selectedCategories: initialCategories = [],
  onCategoriesChange,
}: CategoriesFilterProps) {
  const [selectedCategories, setSelectedCategories] =
    useState<string[]>(initialCategories);

  const toggleCategory = (category: string) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  const handleApply = () => {
    if (onCategoriesChange) {
      onCategoriesChange(selectedCategories);
    }
    onClose();
  };

  const totalCategories = allCategories.length;

  return (
    <>
      {/* Scrollable content */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <CategorySelector
          selectedCategories={selectedCategories}
          onToggleCategory={toggleCategory}
          allCategories={allCategories}
        />
      </div>

      {/* Fixed bottom button */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          backgroundColor: '#ffffff',
          borderTop: '1px solid #e5e7eb', // gray-200
          zIndex: 20,

          width: '100%',

          paddingLeft: '20px',
          paddingRight: '20px',
          paddingTop: '16px',
          paddingBottom: '16px',

          marginLeft: '0px',
          marginRight: '0px',
          marginBottom: '0px',
        }}
      >
        <FilterActionButton onClick={handleApply}>
          Aplicar categorias
        </FilterActionButton>

        <p
          style={{
            fontSize: '0.75rem', // text-xs
            lineHeight: '1rem',
            color: '#6b7280', // gray-500
            textAlign: 'center',
            marginTop: '0.75rem', // mt-3
          }}
        >
          {totalCategories}{' '}
          {totalCategories === 1
            ? 'categoria disponível'
            : 'categorias disponíveis'}
        </p>
      </div>
    </>
  );
}
